import { fetchAuthSession } from "@aws-amplify/auth";
import axios from "axios";

export type DeliveryOpenRateAnalyticsResponse = {
  [deliveryId: string]: DeliveryOpenRateAnalytics;
};

export type DeliveryOpenRateAnalytics = {
  deliveryId: string; // 配信ID
  totalSent: number; // 総送信数
  uniqueOpens: number; // ユニーク開封数
  uniqueClicks: number; // ユニーククリック数
  openRate: number; // 開封率 (%)
  clickRate: number; // クリック率 (%)
  clickToOpenRate: number; // クリック/開封率 (%)
};

export type DeliveryOpenRateAPIResponse = {
  success: {
    [deliveryId: string]: DeliveryOpenRateAnalytics;
  };
  errors: {
    [deliveryId: string]: string;
  };
};

export const getOpenRateAnalytics = async (
  deliveryIds: string[],
): Promise<DeliveryOpenRateAnalyticsResponse> => {
  const { tokens } = await fetchAuthSession();
  const idToken = tokens?.idToken?.toString();

  const response = await axios.post(
    process.env.REACT_APP_EMAILS_OPEN_RATE_ENDPOINT!,
    {
      deliveryIds,
    },
    {
      headers: {
        Authorization: `Bearer ${idToken}`,
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    },
  );

  if (response.status !== 200) {
    throw new Error(response.data.message);
  }

  const errors = response.data.errors;
  if (Object.keys(errors).length > 0) {
    console.debug("Open rate analytics errors:", errors);
  }

  // 成功した配信IDの結果のみを返す
  return response.data.success;
};
